// Semáforo del costeo automático (job no-POS) — Parte 7.
// UNA regla en UN lugar: la usan la tarjeta de "Estado del sistema" (Configuración)
// y la alerta condicional de Inicio. Si vivieran separadas, un día la tarjeta diría
// verde y la alerta gritaría — el desacuerdo es peor que cualquiera de los dos colores.
//
// ROJO  = el veredicto de salud falló (duplicados / cuadre descuadrado / negativos).
// ÁMBAR = activo pero frenado (kill switch) o lleva mucho sin correr (>6 intervalos).
// GRIS  = apagado — estado ESPERADO hasta la activación: no alarma.
// VERDE = activo y al día.

export function haceCuanto(min) {
  if (min == null) return 'nunca corrió';
  if (min < 2) return 'hace un momento';
  if (min < 60) return `hace ${min} min`;
  const h = Math.round(min / 60);
  return `hace ${h} ${h === 1 ? 'hora' : 'horas'}`;
}

// UNA SOLA FUENTE DE VERDAD: lastRunAt. "Corrió" ⟺ lastRunAt existe; los minutos se
// derivan de ahí si el backend no los manda. La primera versión decidía "nunca corrió"
// por el campo DERIVADO (minutosDesdeUltimaCorrida) mientras la grilla mostraba el
// campo FUENTE — y con un backend viejo + frontend nuevo (que pasa ~1 minuto en CADA
// deploy, y pasó en local el 28-jul) el panel decía "nunca corrió" al lado de la fecha
// de la última corrida. Dos campos que pueden discrepar = dos verdades.
export function minutosDesdeCorrida(resumen) {
  const r = resumen || {};
  if (r.minutosDesdeUltimaCorrida != null) return r.minutosDesdeUltimaCorrida;
  if (!r.lastRunAt) return null;
  const t = new Date(r.lastRunAt).getTime();
  return Number.isNaN(t) ? null : Math.max(Math.round((Date.now() - t) / 60000), 0);
}

export function semaforoDelJob(health) {
  if (!health) return { tono: 'gris', titulo: 'Sin datos', detalle: 'No se pudo consultar el estado del costeo automático.' };
  const r = health.resumen || {};
  if (health.veredicto !== 'ok') {
    return {
      tono: 'rojo',
      titulo: 'El costeo automático tiene algo que revisar',
      detalle: `${(health.duplicados || []).length} duplicados · ${(health.cuadreDescuadrado || []).length} lotes descuadrados · ${health.lotesNegativos || 0} negativos.`,
    };
  }
  if (!r.activo) {
    return { tono: 'gris', titulo: 'Apagado', detalle: 'El costeo automático de ventas web aún no se activó. Los libros no se mueven solos.' };
  }
  const intervalo = r.scheduler?.intervaloMinutos || 10;
  if (r.scheduler?.killSwitch) {
    return { tono: 'ambar', titulo: 'Activo pero FRENADO', detalle: 'El kill switch está puesto: la frontera existe pero el scheduler no corre.' };
  }
  if (!r.lastRunAt) {
    return { tono: 'ambar', titulo: 'Activo pero todavía sin correr', detalle: 'Se activó y aún no registra ninguna corrida.' };
  }
  const min = minutosDesdeCorrida(r);
  if (min == null || min > intervalo * 6) {
    return {
      tono: 'ambar',
      titulo: 'Activo pero lleva mucho sin correr',
      detalle: `Última corrida ${haceCuanto(min)}; debería correr cada ${intervalo} min.`,
    };
  }
  return { tono: 'verde', titulo: 'Activo y al día', detalle: `Última corrida ${haceCuanto(min)}.` };
}
